import { createSelector } from 'reselect';

const selectWorkspaceRoot = (state) => state.workspace;

export const selectWorkspaceList = createSelector(
    [selectWorkspaceRoot],
    (workspace) => workspace.list
);

export const selectCurrentWorkspace = createSelector(
    [selectWorkspaceRoot],
    (workspace) => workspace.currentWorkspace
);

export const selectWorkspacePlan = createSelector(
    [selectWorkspaceRoot],
    (workspace) => workspace.plan
);

export const selectWorkspaceRestrictions = createSelector(
    [selectWorkspaceRoot],
    (workspace) => workspace.restrictions
);

export const selectWorkspaceTeams = createSelector(
    [selectWorkspaceRoot],
    (workspace) => workspace.teams
);

export const selectWorkspaceMembers = createSelector(
    [selectWorkspaceRoot],
    (workspace) => workspace.members
);

export const selectWorkspaceInvites = createSelector(
    [selectWorkspaceRoot],
    (workspace) => workspace.invites
);

export const selectWorkspaceIsInitialized = createSelector(
    [selectWorkspaceRoot],
    (workspace) => workspace.isInitialized
);

export const selectWorkspaceIsLoading = createSelector(
    [selectWorkspaceRoot],
    (workspace) => workspace.isLoading
);

export const selectWorkspaceError = createSelector(
    [selectWorkspaceRoot],
    (workspace) => workspace.error
);

export const selectPendingSwitchId = createSelector(
    [selectWorkspaceRoot],
    (workspace) => workspace.pendingSwitchId
);

export const selectCanInviteWorkspaceMembers = createSelector(
    [selectCurrentWorkspace, selectWorkspacePlan],
    (ws, plan) => plan === 'free' || ws?.my_role === 'owner' || ws?.my_role === 'admin'
);

// --- Derived restriction selectors (read the { caps, can } matrix shape) ---

export const selectIsPro = createSelector(
    [selectWorkspacePlan],
    (plan) => (plan || 'free') !== 'free'
);

export const selectCanCollaborate = createSelector(
    [selectWorkspaceRestrictions],
    (restrictions) => restrictions?.can?.collaborate ?? true
);

export const selectCanShareDiagrams = createSelector(
    [selectWorkspaceRestrictions],
    (restrictions) => restrictions?.can?.shareDiagrams ?? true
);

export const selectCanShareAllRoles = createSelector(
    [selectWorkspaceRestrictions],
    (restrictions) => restrictions?.can?.admin_roles ?? false
);

// Everyone can invite up to the members cap; gating is the cap, not a capability.
export const selectCanInviteMembers = createSelector(
    [selectWorkspaceRestrictions],
    () => true
);

export const selectMaxDiagrams = createSelector(
    [selectWorkspaceRestrictions],
    (restrictions) => restrictions?.caps?.diagrams ?? 4
);

export const selectMaxSeats = createSelector(
    [selectWorkspaceRestrictions],
    (restrictions) => restrictions?.caps?.members ?? 4
);

// True when the user has reached the diagram limit for their plan.
// diagramCount must be passed as a second argument to the selector factory.
export const makeSelectIsDiagramLimitReached = () => createSelector(
    [selectMaxDiagrams, (_state, diagramCount) => diagramCount],
    (maxDiagrams, diagramCount) => {
        if (maxDiagrams === -1) return false;
        return diagramCount >= maxDiagrams;
    }
);
